interface MainPanelTopbarProps {
  onGoHome: () => void;
}

export default function MainPanelTopbar({ onGoHome }: MainPanelTopbarProps) {
  return (
    <div className="main-panel-topbar">
      <button
        type="button"
        className="btn btn-secondary main-panel-home-btn"
        onClick={onGoHome}
      >
        ← Home
      </button>
    </div>
  );
}
